import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Services from "../Services";
import ConnectionDetails from "./ConnectionDetails";

function CreateConnection({
  setConnection,
  dataCenter,
  orgId,
  apiKey,
  zApiKey,
  setSnack,
  currentUser,
  handlefetchConnections,
}) {
  const [expanded, setExpanded] = useState("panel1");
  const [service, setService] = useState();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded((prev) => (newExpanded ? panel : false));
  };

  return (
    <Box>
      {/* <>{JSON.stringify(service)}</> */}
      <Box pl={10} pt={5} sx={{ width: "80%" }}>
        <Box>
          <Box display={"flex"}>
            <ArrowBackIosIcon
              sx={{ color: "#757575", "&:hover": { color: "black" } }}
              onClick={() => setConnection((prev) => "list")}
            />
            <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
              Create Connection
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "12px",
                color: "text.secondary",
                width: "98%",
              }}
            >
              Provide the connection details for the required service and click
              'Create and Connect'. In the next step, you will need to
              authenticate with your login details in order to utilize the
              connection.
            </Typography>
          </Box>
        </Box>
        <Box mt={3} sx={{}}>
          {/* <>{JSON.stringify(service)}</> */}
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography>
                {" "}
                {service
                  ? `Selected Service: ${service?.name}`
                  : "1. Pick Your Service"}{" "}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Services
                dataCenter={dataCenter}
                orgId={orgId}
                apiKey={apiKey}
                zApiKey={zApiKey}
                setService={setService}
                setExpanded={setExpanded}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              aria-controls="panel2-content"
              id="panel2-header"
              sx={{
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                "&.Mui-expanded": {
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                },
              }}
            >
              <Typography sx={{ fontSize: "15px" }}>
                2. Connection Details
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {service ? (
                <ConnectionDetails
                  service={service}
                  setSnack={setSnack}
                  dataCenter={dataCenter}
                  orgId={orgId}
                  apiKey={apiKey}
                  zApiKey={zApiKey}
                  currentUser={currentUser}
                  handlefetchConnections={handlefetchConnections}
                />
              ) : (
                <></>
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
      </Box>
      {/* <Box
        pl={10}
        pt={5}
        sx={{ display: "flex", marginTop: "20px", width: "80%" }}
      >
        <Button variant="contained" sx={{ textTransform: "none" }}>
          Create And Connect
        </Button>
        <Button
          sx={{
            color: "#757575",
            bgcolor: "#eeeeee",
            marginLeft: "20px",
            textTransform: "none",
          }}
        >
          Cancel
        </Button>
      </Box> */}
    </Box>
  );
}

export default CreateConnection;
